export default __webpack_public_path__ + "static/media/desert-flower.004349af642e772e1121bb1e5a7b8a47.svg";